<template>
  <el-container>
    <el-header class="header">
      <img class="img_logo" src="@/assets/images/logo.png" alt=""/>
      <img class="img_rectangle" src="@/assets/images/rectangle.png" alt=""/>
      <img class="img_title" src="@/assets/images/title.png" alt=""/>
      <img class="img_osp" src="@/assets/images/osp_logo.png" alt=""/>
    </el-header>
    <img class="hf_logo2" src="@/assets/images/hf_logo2.png" alt=""/>
    <el-main class="main">
      <el-main>
        <h6 class="text">请选择要注册的账号</h6>
      </el-main>
      <el-main>
        <el-button class="but but1" @click="registerByIDCard">
          <span class="sp">通过身份证号码注册</span>
        </el-button>
      </el-main>
      <el-main>
        <el-button class="but but2" @click="registerByNumber">
          <span class="sp">通过EAS编码注册</span>
        </el-button>
      </el-main>
      <el-main>
        <el-button class="but but3" @click="driverFindPass">
          <span class="sp">提货司机找回密码</span>
        </el-button>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>
export default {
  methods: {
    registerByIDCard(){
      this.$router.push({ path: "/registerByIDCard" });
    },
    registerByNumber(){
      this.$router.push({ path: "/registerByNumber" });
    },
    driverFindPass(){
      this.$router.push({ path: "/registerFindPass" });
    }
  }
}
</script>

<style scoped>
  .header{
    /* 矩形 136 */
    position: absolute;
    width: 100%;
    height: 81px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 675px;
    background: linear-gradient(180.00deg, rgba(239,49,67,1) 0%,rgba(249,105,120,1) 100%);
  }
  .img_logo{
    /* 标识基础规范2：禾丰股份1 */
    position: absolute;
    width: 169px;
    height: 43px;
    left: 30px;
    right: 1081px;
    top: 10px;
    bottom: 687px;
  }
  .img_rectangle{
    /* 矩形 173 */
    position: absolute;
    width: 3px;
    height: 35px;
    left: 222px;
    right: 1055px;
    top: 14px;
    bottom: 691px;
  }
  .img_title{
    /* 小禾订货平台 */
    position: absolute;
    width: 226px;
    height: 56px;
    left: 186px;
    right: 856px;
    top: 14px;
    bottom: 682px;
  }
  .img_osp{
    /* OSP */
    position: absolute;
    float: right;
    width: 298px;
    height: 66px;
    right: 39px;
    top: 0;
    bottom: 672px;
  }
  .main{
    position: relative;
    top: 138px;
    text-align: center;
  }
  .text{
    /* 请选择要注册的账号 */
    position: absolute;
    width: 100%;
    height: 35px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 583px;

    background: linear-gradient(180.00deg, rgba(240,53,71,1) 0%,rgba(255,137.6,149.58,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: center;
  }
  .but{
    /* 矩形 171 */
    /*position: absolute;*/
    width: 299px;
    height: 42px;

    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1) 0%,rgba(253,131,145,1) 100%);
    border-radius: 20px;
    border: none;
  }
  .but1{
    top:200px;
  }
  .but2{
    top:272px;
  }
  .but3{
    top:340px;
    background: linear-gradient(180.00deg, rgba(80,128,248,1) 0%,rgba(106,167,253,1) 100%);
  }
  .sp{
    /* 通过身份证号码注册 */
    width: 274px;
    height: 31px;

    color: rgb(255, 255, 255);
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 1px;
  }
  .hf_logo2{
    position: absolute;
    bottom: 0;
    width: 800px;
    height: 600px;
  }
</style>
